import { useContext } from 'react';
import { DatasContext } from 'providers/Datas';

const useDatas = () => useContext(DatasContext);

export default useDatas;
